// "Hanya yang terakhir yang menang" untuk request beruntun dari satu kontrol UI.
// Lahir dari bug tab periode (Harian/Bulanan/Tahunan) di halaman properti/unit: klik cepat
// memicu beberapa GET /roomAvailability/detail-v2, dan respons tab LAMA yang datang belakangan
// menimpa harga tab baru (harga nyangkut di Tahunan). Membuang request baru selama ada yang
// jalan justru lebih parah — tab terakhir tak pernah dijemput sama sekali.
//
// Pemakaian:
//   const gate = createLatestRequest();        // sekali per sumber request
//   const turn = gate.start();                 // membatalkan giliran sebelumnya
//   const res = await api.get(url, { signal: turn.signal });
//   if (!turn.isLatest()) return null;         // sudah disusul → jangan sentuh state
//
// `signal` opsional: pemakai yang tak memegang request HTTP (mis. komponen yang cuma perlu
// tahu "loading ini masih milik klik terakhir?") boleh mengabaikannya.
export function createLatestRequest() {
   let latestId = 0;
   let currentAbort = null;

   return {
      start() {
         currentAbort?.abort();
         // AbortController ada di semua browser target & Node 16+; tak perlu polyfill.
         currentAbort = typeof AbortController === "function" ? new AbortController() : null;
         const id = ++latestId;
         return {
            id,
            signal: currentAbort?.signal,
            isLatest: () => id === latestId,
         };
      },
   };
}

// Request yang dibatalkan giliran berikutnya selalu bukan yang terakhir, jadi `isLatest()`
// sudah cukup untuk membedakan "batal karena disusul" dari error jaringan sungguhan —
// tak perlu mengenali bentuk error axios (`ERR_CANCELED`/`CanceledError`).
export default createLatestRequest;
